module.exports = __webpack_public_path__ + "img/digest.ef277715.svg";